// extracted by mini-css-extract-plugin
module.exports = {"root":"CreateSupportTicketDialog_root__HpS_d","happyPeaceSignImage":"CreateSupportTicketDialog_happyPeaceSignImage__P8wC_"};